import { useEffect } from 'react';

type UseInitialLoadProps = {
    loaderCallback: () => void;
};

const useInitialLoad = ({ loaderCallback }: UseInitialLoadProps) => {
    useEffect(() => {
        const element = document.querySelector('.jodit_fullsize-box_true');
        if (element) {
            window.location.reload();
        } else {
            loaderCallback();
        }
    }, []);
};

export default useInitialLoad;
